<script setup>
import { Button, Card, InputNumber, Select, Switch } from 'ant-design-vue';
import { useBookingServiceSettings } from '@/composables/useBookingServiceSettings';

const {
    canUpdate,
    loading,
    saving,
    selectedCode,
    form,
    serviceOptions,
    onSelectService,
    save
} = useBookingServiceSettings({ mode: 'window' });
</script>

<template>
    <div class="params-page pb-10">
        <Card :bordered="false" class="admin-panel" :loading="loading">
            <div class="params-head">
                <label>
                    <span>服務</span>
                    <Select
                        :value="selectedCode"
                        style="width: 220px"
                        :disabled="loading"
                        :options="serviceOptions"
                        @change="onSelectService"
                    />
                </label>
                <Button v-if="canUpdate" type="primary" :loading="saving" @click="save">儲存</Button>
            </div>
        </Card>

        <div class="params-grid">
            <Card :bordered="false" class="admin-panel" :loading="loading">
                <h2>可約區間</h2>
                <div class="params-fields">
                    <label>
                        <span>最早（今天後幾天）</span>
                        <InputNumber
                            v-model:value="form.booking_window_min_days"
                            :min="0"
                            :max="365"
                            :disabled="!canUpdate"
                        />
                    </label>
                    <label>
                        <span>最遠（今天後幾天）</span>
                        <InputNumber
                            v-model:value="form.booking_window_max_days"
                            :min="0"
                            :max="365"
                            :disabled="!canUpdate"
                        />
                    </label>
                </div>
            </Card>

            <Card :bordered="false" class="admin-panel" :loading="loading">
                <h2>同時段上限</h2>
                <div class="params-fields">
                    <label>
                        <span>全站上限</span>
                        <InputNumber
                            v-model:value="form.offline_capacity_per_slot"
                            :min="1"
                            :max="50"
                            :disabled="!canUpdate"
                        />
                    </label>
                    <label class="params-switch">
                        <span>開放線上</span>
                        <Switch v-model:checked="form.online_supported" :disabled="!canUpdate" />
                    </label>
                    <label class="params-switch">
                        <span>開放實體</span>
                        <Switch v-model:checked="form.offline_supported" :disabled="!canUpdate" />
                    </label>
                </div>
            </Card>
        </div>
    </div>
</template>

<style scoped>
.params-page {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.params-head {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: flex-start;
}
.params-head label,
.params-fields label {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 13px;
    color: #3f3a33;
}
.params-page h2 {
    margin: 0 0 12px;
    font-size: 16px;
}
.params-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
}
.params-fields {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: flex-end;
}
.params-switch {
    min-width: 96px;
}
@media (max-width: 960px) {
    .params-grid,
    .params-head {
        display: flex;
        flex-direction: column;
    }
}
</style>
